import { render, staticRenderFns } from "./icon-location.vue?vue&type=template&id=5a2bb18a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2bb18a')) {
      api.createRecord('5a2bb18a', component.options)
    } else {
      api.reload('5a2bb18a', component.options)
    }
    module.hot.accept("./icon-location.vue?vue&type=template&id=5a2bb18a&", function () {
      api.rerender('5a2bb18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/icons/icon-location.vue"
export default component.exports